import WalletService from "../../service/WalletService";
//import swal from 'sweetalert'

export const namespaced = true

export const state = {
    walletsLoading: true,
    walletTransactionsLoading: true,
    wallets: [],
    mainWalletsLoading: true,
    walletTransactions: [],
    walletMetrics: {
        type:'last30',
        startDate:null,
        endDate:null,
    },
    response: {},
    mainWallets: []
}


export const getters = {
}


export const mutations = {
    updateWallets: (state, payload) =>{
        state.wallets = payload
    },
    updateMainWallets: (state, payload) =>{
        state.mainWallets = payload
    },
    updateWalletMetrics: (state, payload) =>{
        state.walletMetrics = payload
    },
    updateWalletTransactions: (state, payload) =>{
        state.walletTransactions = payload
    },
    updateResponse: (state, payload) =>{
        state.response = payload
    },
    updateWalletsLoading: (state, payload) =>{
        // console.log('Entered Mutation updateIsDocumentsUpt', payload);
        state.walletsLoading = payload;
    },
    updateMainWalletsLoading: (state, payload) =>{
        // console.log('Entered Mutation updateIsDocumentsUpt', payload);
        state.mainWalletsLoading = payload;
    },
    updateWalletTransactionsLoading: (state, payload) =>{
        // console.log('Entered Mutation updateIsDocumentsUpt', payload);
        state.walletTransactionsLoading = payload;
    },
    reset: (state, payload) =>{
        state.walletsLoading = payload;
        state.wallets = {};
        state.response = {};
    },
}


export const actions = {
    readWallets: ({ commit,state }, payload)=>{
        console.log("updateDocuments>>>>>>"+state.wallets.length)
        if(state.wallets.length < 1)
            commit("updateWalletsLoading", true);
        return WalletService.callReadWalletApi(payload)
            .then(response => {
                commit("updateWalletsLoading", false)
                if (response.data.responseCode === "00") {
                    console.log(response.data.data)
                    commit("updateWallets", response.data.data)
                }else{
                    commit("updateWallets", [])
                }

            })
            .catch(error => {
                commit("updateWalletsLoading", false)
                alert(error)
                // throw error;
            });
    },
    getWallets: ({ commit,state }, payload)=>{
        console.log("updateMainWallets>>>>>>"+state.mainWallets.length)
        if(state.mainWallets.length < 1)
            commit("updateMainWalletsLoading", true);
        return WalletService.callGetWalletApi(payload)
            .then(response => {
                commit("updateMainWalletsLoading", false)
                if (response.data.responseCode === "00") {
                    console.log(response.data.data)
                    commit("updateMainWallets", response.data.data)
                }else{
                    commit("updateMainWallets", [])
                }

            })
            .catch(error => {
                commit("updateMainWalletsLoading", false)
                alert(error)
                // throw error;
            });
    },

    readWalletTransactions: ({ commit,state }, payload)=>{
        console.log("updateDocuments>>>>>>"+state.walletTransactions.length);
        if(state.walletTransactions.length < 1)
            commit("updateWalletTransactionsLoading", true);
        payload.startDate = state.walletMetrics.startDate;
        payload.endDate = state.walletMetrics.endDate;
        return WalletService.callReadWalletTransactionsApi(payload)
            .then(response => {
                commit("updateWalletTransactionsLoading", false);
                if (response.data.responseCode === "00") {
                    console.log(response.data.data);
                    commit("updateWalletTransactions", response.data.data)
                }else{
                    commit("updateWalletTransactions", [])
                }

            })
            .catch(error => {
                commit("updateWalletTransactionsLoading", false)
                alert(error)
                // throw error;
            });
    },
    reset: ({ commit }, payload)=>{
        commit("reset",payload)
    }
}
